document.addEventListener('DOMContentLoaded', function() {
  const swiperMain = new Swiper(".js-image-slider", {
    autoHeight : true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    }
  })

  const swatchLabel = document.querySelectorAll('.js-swatch-label');
  const body = document.querySelector('body');
  const swatchInput = document.querySelectorAll('.product-swatch__dropdown-item');

  if(swatchInput) {
    swatchInput.forEach(function(input) {
      input.addEventListener('click', function() {
        const item = input.closest('.js-swatch-label');
        let selectedBlock = document.querySelector('.js-selling-plan-block.selected');
        item.querySelector('.js-swatch-name').innerHTML = input.textContent;
        item.classList.add('active');
        if(selectedBlock) {
          selectedBlock.classList.remove('overflow');
        }
      })
    })
  }

  if(swatchLabel) {
    swatchLabel.forEach(function(item) {
      item.onclick = () => {
        const activeLabel = document.querySelector('.js-swatch-label.selected');
        let selectedBlock = document.querySelector('.js-selling-plan-block.selected');
        item.classList.add('selected');
        if(activeLabel) {
          activeLabel.classList.remove('selected');
        }
        if(selectedBlock) {
          selectedBlock.classList.toggle('overflow');
        }
      }
    })
  }

  body.addEventListener('click', function(event) {
    swatchLabel.forEach(function(item) {
      if (!item.contains(event.target)) {
        item.classList.remove('selected');
      }
    })
  });

  const zoomImage = document.querySelectorAll('.product-zoom');
  if(zoomImage) {
    zoomImage.forEach(function(zoom) {
      zoom.onmousemove = (e) => {
        var zoomer = e.currentTarget;
        e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
        e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
        x = offsetX/zoomer.offsetWidth*100
        y = offsetY/zoomer.offsetHeight*100
        zoomer.style.backgroundPosition = x + '% ' + y + '%';
      }
    })
  };

  const selling_plans = document.querySelectorAll('.js-membership-selling-plans');
  const inputVariantID = document.querySelector('.js-selected-variant-id');
  const sellingPlanID = document.querySelector('#sellingPlan');
  if(selling_plans) {
    selling_plans.forEach(function(item) {
      item.onchange = () => {
        let variantID = item.getAttribute('data-id');
        let selling_plans_id = item.value;
        inputVariantID.value = variantID;
        sellingPlanID.value = selling_plans_id;
      }
    });
  }
})
